export { default as ListadoArticulosVendidos } from "./Listado";
